<div class=" pl-md-3 pr-md-3 pr-sm-0 pl-sm-0 mb-2" >

            <img class="img-fluid" *ngIf="product" src="{{getImageURL()}}" (click)="openImageDialog($event , -1)">
<!--<lib-ngx-image-zoom style="width: 500px"  *ngIf="product"-->
<!--                    [thumbImage]="getImageURL()"-->
<!--                    [magnification]="1"-->
<!--                    [zoomMode]="hover"-->
<!--                    [enableScrollZoom]="true"-->
<!--                    [enableLens]="false"-->
<!--                    (click)="openImageDialog($event,-1)"-->
<!--&gt;</lib-ngx-image-zoom>-->
        </div>


<!--<div class="container" style="width: 500px">-->
<!--    <div class="inner"  style="width: 500px;">-->
<!--<img class="module img-fluid hover-shadow cursor"  [ngStyle]="{backgroundImage: 'url('+ getImageURL()+')'} " (mouseout)="resetPositon()" (mousemove)="changePosition($event)" id="myDiv" style="background-size: 500px" >-->


<!--    </div>-->
<!--</div>-->


<!--    <img (mousemove)="changePosition($event)"  (click)="openPopup()"  src="{{getImageURL()}}" class="img-fluid hover-shadow cursor"  style="width: 500px;" />-->







<!--<div-->
<!--        class="modal"-->
<!--        tabindex="-1"-->
<!--        role="dialog"-->
<!--        [ngStyle]="{'display':displayStyle}">-->
<!--    <div class="modal-dialog" role="document">-->
<!--        <div class="modal-content">-->
<!--            <div class="modal-body">-->
<!--                <img (click)="openPopup()" src="{{getImageURL()}}" class="img-fluid" style="width: 5000px;" />-->

<!--            </div>-->
<!--            <div class="modal-footer">-->
<!--                <button type="button" class="btn btn-primary"-->
<!--                        (click)="closePopup()">-->
<!--                    Close-->
<!--                </button>-->
<!--            </div>-->
<!--        </div>-->
<!--    </div>-->
<!--</div>-->
